import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChild, AfterViewInit, OnInit } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { TslDialog, TslFileDrop, TslToastrService } from "@tesla/ng-tds";
import { isNullOrUndefined } from "util";
import { isNullOrEmpty, validateAllFormFields } from "../../shared/utils/utils";
import { GeneralSettings, KeyValuePair } from "../../profile/models/generic.model";
import { CustomValidator } from "../../shared/custom-validator/custom-validator";
import { BankConfig, BankConfiguration, Currency, OPERATION, Permission, SupplierBank, SupplierBankPropertyValue, SupplierDocument } from "../../profile/models/supplier.model";
import { BankUploadFileModel } from "./bank-upload-file.model";
import { I18nService } from "../../shared/services/i18n.service";
import { SupplierDocumentService } from '../../profile/services/supplier-document.service';
import { DocumentType } from '../../profile/models/supplier.model';
import { SelectAutocompleteComponent } from "../autocomplete/select-autocomplete.component";
import { OnboardingDocumentsService } from "../../profile/services/onboarding-document.service";
import * as FileSaver from 'file-saver';
import { BankCountryConfig } from 'app/profile/models/bank.model';
import { BankService } from 'app/profile/services/bank.service';
import { PayoutProps } from '@tesla/payout-react';
import { AddAccountResult } from '@tesla/payout-react/dist/payout-interface';
import { PayoutAngularComponent } from '@tesla/payout-angular';
import { AppSettings } from '../../app.settings';
import { ClearEvent } from 'app/profile/store/app.actions';
import { VerificationStatus, US_STATE_LIST } from 'app/shared/constants';
import { LanguageService } from "app/core/services/language.service";
import { OnboardingDocument } from "app/profile/models/onboarding.model";
import { MatDialog } from '@angular/material/dialog';
import { SecurityCheckComponent } from "app/profile/components/bank/bank-grid/security-check/security-check.component";
import { Router } from "@angular/router";


@Component({
  selector: 'bank-edit',
  templateUrl: './bank-edit.component.html',
  styleUrls: ['./bank-edit.component.scss']
})
export class BankEditComponent implements AfterViewInit, OnChanges, OnInit {
  isIBANEdited: boolean = false;
  isAccountNumberEdited: boolean = false;
  isIntermediaryAccountNumberEdited: boolean = false;
  originalAccountNumber: string = '';
  originalIbanNumber: string = '';
  invalidDoc: boolean = false;
  types: DocumentType[] = [];
  categories: string[] = [];
  allowedExtensions: string = "";
  showIntermediaryBankingFields: boolean = false;
  showNameDifferentReason: boolean = false;
  showNameDifferentReasonComment: boolean = false;
  USAstate: boolean = false;
  beneficiaryNameDifferentReasons = [
    "Company acquisition, reorganization, or merger",
    "Factoring Agent or third-party financial services",
    "Parent, child or sister company used for accounts receivable",
    "Other, please provide details"
  ]

  /** Array of error messages to display at the edit form */
  errors: string[];

  /** Form group of all the controls for the detils of the bank */
  bankForm: FormGroup;

  /** Form group of all controls for the documents */
  documentsForm: FormGroup;

  @ViewChild('payoutRefAngular')
  payoutRefAngular: PayoutAngularComponent;
  payoutData: PayoutProps;
  isChina: boolean = false;
  languageSelected: string;

  supplierBankKeyMap: any = [
    {
      'SupplierBankKey' : 'PaymentOrigin',
      'IsConditional' : true,
      'ConditionValue': 'this.showPaymentOriginControl == true',
      'SupplierBankControlKeyList' : 'this.paymentOriginAutocomplete.selectedValue || this.paymentOriginAutocomplete.formControl.value',
      'SupplierBankControlKey' : null
    },
    {
      'SupplierBankKey' : 'CurrencyCode',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.currecyAutocomplete?.selectedValue'
    },
    {
      'SupplierBankKey' : 'BankName',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.Name?.value'
    },
    {
      'SupplierBankKey' : 'BankLocalName',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.BankLocalName?.value'
    },
    {
      'SupplierBankKey' : 'BankNickName',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.NickName?.value'
    },
    {
      'SupplierBankKey' : 'BeneficiaryNameEnglish',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.BeneficiaryNameEnglish?.value'
    },
    {
      'SupplierBankKey' : 'BeneficiaryNameDifferentReason',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.BeneficiaryNameDifferentReason?.value'
    },
    {
      'SupplierBankKey' : 'BeneficiaryNameLocal',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.BeneficiaryNameLocal?.value'
    },
    {
      'SupplierBankKey' : 'SwiftCode',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.SwiftCode?.value'
    },
    {
      'SupplierBankKey' : 'PaymentType',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.PaymentType?.value'
    },
    {
      'SupplierBankKey' : 'BankAccountNameKatanaka',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.BankAccountNameKatanaka?.value'
    },
    {
      'SupplierBankKey' : 'BankAccountType',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.BankAccountType?.value'
    },
    {
      'SupplierBankKey' : 'Address1',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.Address1?.value'
    },
    {
      'SupplierBankKey' : 'Address2',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.Address2?.value'
    },
    {
      'SupplierBankKey' : 'City',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.City?.value'
    },
    {
      'SupplierBankKey' : 'State',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.State?.value'
    },
    {
      'SupplierBankKey' : 'ZipCode',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.ZipCode?.value'
    },
    {
      'SupplierBankKey' : 'Comments',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.Comments?.value'
    },
    {
      'SupplierBankKey' : 'ABANumber',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.RoutingCode?.value'
    },
    {
      'SupplierBankKey' : 'IsNewBankAccount',
      'IsConditional' : true,
      'ConditionValue': 'this.supplierBank.TempID == false',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls?.IsNewBankAccount?.value'
    },
    {
      'SupplierBankKey' : 'IsIntermediaryBanking',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IsIntermediaryBanking?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryPaymentOrigin',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryPaymentOrigin?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryBankName',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryBankName?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryBankRouting',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryBankRouting?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryBankSwiftCode',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryBankSwiftCode?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryBankAccount',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryBankAccount?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryCountryCode',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.intermCountryAutocomplete?.selectedValue'
    },
    {
      'SupplierBankKey' : 'IntermediaryZipCode',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryZipCode?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryCity',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryCity?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryState',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryState?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryAddress1',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryAddress1?.value'
    },
    {
      'SupplierBankKey' : 'IntermediaryAddress2',
      'IsConditional' : true,
      'ConditionValue': 'this.BankformControls?.IsIntermediaryBanking?.value == true',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IntermediaryAddress2?.value'
    },
    {
      'SupplierBankKey' : 'IsNewIntermediaryBankAccount',
      'IsConditional' : false,
      'ConditionValue': '',
      'SupplierBankControlKeyList' : [],
      'SupplierBankControlKey' : 'this.BankformControls.IsNewIntermediaryBankAccount?.value'
    },
  ];

  /** Determines if the controls should be disabled */
  @Input('tsl-readOnly') readOnly = false;

  /** Determines if the controls should be disabled */
  @Input('tsl-showPaymentOriginControl') showPaymentOriginControl = false;

  /** Collection of supported countries */
  @Input('tsl-countries') countries: BankCountryConfig[] = [];

  /** Collection of supported currencies */
  @Input('tsl-currencies') currencies: Currency[];

  /** Bank configuration */
  @Input('tsl-bankConfiguration') bankConfiguration: BankConfiguration;

  /** Array of key value pairs of payment origins */
  @Input('tsl-paymentOrigins') paymentOrigins: KeyValuePair<string, string>[];

  /** Array of key value pairs of intermediary payment origins */
  @Input('tsl-intermediaryPaymentOrigins') intermediaryPaymentOrigins: KeyValuePair<string, string>[];

  /** General settings of the application */
  @Input('tsl-generalSettings') settings: GeneralSettings;

  /** Initial bank data to set values of the bank form */
  @Input('tsl-initialData') initialData: SupplierBankPropertyValue = new SupplierBankPropertyValue();

  /** Used to determine if the document section should be displayed or not */
  @Input('tsl-hideDocumentSection') hideDocumentSection: boolean = false;

  /** Supplier bank details from the parent component */
  @Input('tsl-supplierBank') supplierBank: SupplierBank = new SupplierBank();

  /** Determines if the app should hide or display the save button */
  @Input('tsl-hideSaveButton') hideSaveButton: boolean = false;

  /** Determines if the app should hide or display the cancel button */
  @Input('tsl-hideCancelButton') hideCancelButton: boolean = false;

  /** Required supplier code to be provided by onboaridng parent component */
  @Input('tsl-supplierCode') supplierCode: string = '';

  /** Label text of the save button */
  @Input('tsl-saveButtonText') saveBtnText: string = 'Save';

  /** Label text of the cancel button */
  @Input('tsl-cancelButtonText') cancelBtnText: string = 'Cancel';

  @Input('tsl-supplierBankDocType') supplierBankDocType: string;

  /** disable account and number and IBAN code */
  @Input('tsl-disableSensitiveFieldModification') disableSensitiveFieldModification: boolean = false;

  /** enable document section validation based on form modification */
  @Input('tsl-enableDocumentSectionValidationBasedOnFieldModification') enableDocumentSectionValidationBasedOnFieldModification: boolean = false;

  @Input('tsl-legalName') legalName: string;

  @Input('tsl-requiredDocuments') requiredBankDocuments: OnboardingDocument;

  /** Event that will be trigger when the cancel button is click */
  @Output('tsl-onCancel') onCancelEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output('tsl-onVerify') onVerifyEvent: EventEmitter<{ supplierBank: SupplierBank }> = new EventEmitter<{ supplierBank: SupplierBank }>();

  /** Event that will be trigger whenever the value of the country dropdown is changed */
  @Output('tsl-onCountryChange') onCountryChangedEvent: EventEmitter<{ countryCode: string }> = new EventEmitter<{ countryCode: string }>();

  /** Event that will be trigger whenever the value of the country dropdown is changed */
  @Output('tsl-onPaymentOriginChange') onPaymentOriginChangedEvent: EventEmitter<{ paymentOrigin: string }> = new EventEmitter<{ paymentOrigin: string }>();

  /** Event to trigger when the form is submitted with valid data */
  @Output('tsl-onSubmit') onSubmitEvent: EventEmitter<{ supplierBank: SupplierBank, uploadFiles: BankUploadFileModel[], isPartialSave?: boolean, isBankDataChanged: boolean }> =
    new EventEmitter<{ supplierBank: SupplierBank, uploadFiles: BankUploadFileModel[], isBankDataChanged: boolean }>();

  /** Event to trigger when the form is submitted with valid data */
  @Output('tsl-onSave') onSaveEvent: EventEmitter<{ supplierBank: SupplierBank }> =
    new EventEmitter<{ supplierBank: SupplierBank }>();

  /** Event to trigger when user submits a form with errors */
  @Output('tsl-onSaveError') onErrorEvent: EventEmitter<{ errorMessage: string }> =
    new EventEmitter<{ errorMessage: string }>();

  /** Event to trigger when step number changes */
  @Output('tsl-stepChanged') stepChangedEvent: EventEmitter<number> = new EventEmitter<number>();

  /** Reference to the country select-autocomplete component */
  @ViewChild('countryAutocomplete', { static: false }) countryAutocomplete: SelectAutocompleteComponent;

  /** Reference to the country select-autocomplete component */
  @ViewChild('paymentOriginAutocomplete', { static: false }) paymentOriginAutocomplete: SelectAutocompleteComponent;

  /** Reference to the country select-autocomplete component */
  @ViewChild('intermCountryAutocomplete', { static: false }) intermCountryAutocomplete: SelectAutocompleteComponent;

  /** Reference to the country select-autocomplete component */
  @ViewChild('currecyAutocomplete', { static: false }) currecyAutocomplete: SelectAutocompleteComponent;

  @ViewChild('fileDrop', {static: false}) fileDrop: TslFileDrop;
  
  @Input('tsl-isSupplierTask') isSupplierTask: boolean = false;

  @Input('tsl-supplierRequestType') supplierRequestType : string = null;

  private bankConfigControlMap = {
    paymentOrigin: 'PaymentOrigin',
    accountNumber: 'AccountNumber',
    iban: 'IBANCode',
    paymentType: 'PaymentType',
    routingCode: 'RoutingCode',
    bankLocalName: 'BankLocalName',
    swiftCode: 'SwiftCode',
    bankAccountKatanaka: 'BankAccountNameKatanaka',
    bankAccountType: 'BankAccountType',
    beneficiaryNameEnglish: 'BeneficiaryNameEnglish',
    beneficiaryNameDifferentReason: 'BeneficiaryNameDifferentReason',
    beneficiaryNameDifferentReasonComment: 'BeneficiaryNameDifferentReasonComment',
    beneficiaryNameLocal: 'BeneficiaryNameLocal',
    address1: 'Address1',
    address2: 'Address2',
    city: 'City',
    state: 'State',
    zipCode: 'ZipCode',
    intermediaryPaymentOrigin: 'IntermediaryPaymentOrigin'
  };

  constructor(
    private fb: FormBuilder,
    private dialog: TslDialog,
    private translate: I18nService,
    private documentService: SupplierDocumentService,
    private bankService: BankService,
    private onboardingDocumentsService: OnboardingDocumentsService,
    private toaster: TslToastrService,
    private config: AppSettings,
    private languageService: LanguageService,
    private matDialog: MatDialog,

    private router: Router,
  ) {
    this.payoutData = {
      environment: this.config.Production ? 'prod' : 'stage'
    }
    this.bankForm = this.fb.group({
      Country: [{
        value: this.supplierBank ? this.supplierBank.CountryCode : null,
        disabled: this.initialData.countryCode.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.countryCode.permission)
      }, Validators.required],
      PaymentOrigin: [{
        value: this.supplierBank ? this.supplierBank.PaymentOrigin : null,
        disabled: this.initialData.paymentOrigin.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.paymentOrigin.permission)
      }],
      Currency: [{
        value: this.supplierBank ? this.supplierBank.CurrencyCode : null,
        disabled: this.initialData.currencyCode.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.currencyCode.permission)
      }, Validators.required],
      Name: [{
        value: this.supplierBank ? this.supplierBank.BankName : null,
        disabled: this.initialData.bankName.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.bankName.permission)
      }, Validators.required],
      BankLocalName: [{
        value: this.supplierBank ? this.supplierBank.BankLocalName : null,
        disabled: this.initialData.bankLocalName.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.bankLocalName.permission)
      }],
      NickName: [{
        value: this.supplierBank ? this.supplierBank.BankNickName : null,
        disabled: this.initialData && this.initialData.id
      }, Validators.required],
      BeneficiaryNameEnglish: [{
        value: this.supplierBank ? this.supplierBank.BeneficiaryNameEnglish : null,
        disabled: this.initialData.beneficiaryNameEnglish.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.beneficiaryNameEnglish.permission)
      }],
      BeneficiaryNameDifferentReason: [{
        value: this.supplierBank ? this.supplierBank.BeneficiaryNameDifferentReason : null,
        // disabled: this.initialData.beneficiaryNameDifferentReason.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.beneficiaryNameDifferentReason.permission)
        disabled: false
      }],
      BeneficiaryNameDifferentReasonComment: [{
        value: this.supplierBank ? this.supplierBank.BeneficiaryNameDifferentReasonComment : null,
        // disabled: this.initialData.beneficiaryNameDifferentReasonComment.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.beneficiaryNameDifferentReason.permission)
        disabled: false
      }],
      BeneficiaryNameLocal: [{
        value: this.supplierBank ? this.supplierBank.BeneficiaryNameLocal : null,
        disabled: this.initialData.beneficiaryNameLocal.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.beneficiaryNameLocal.permission)
      }],
      Address1: [{
        value: this.supplierBank ? this.supplierBank.Address1 : null,
        disabled: this.initialData.address1.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.address1.permission)
      }],
      Address2: [{
        value: this.supplierBank ? this.supplierBank.Address2 : null,
        disabled: this.initialData.address2.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.address2.permission)
      }],
      City: [{
        value: this.supplierBank ? this.supplierBank.City : null,
        disabled: this.initialData.city.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.city.permission)
      }],
      State: [{
        value: this.supplierBank ? this.supplierBank.State : null,
        disabled: this.initialData.state.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.state.permission)
      }],
      ZipCode: [{
        value: this.supplierBank ? this.supplierBank.ZipCode : null,
        disabled: this.initialData.zipCode.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.zipCode.permission)
      }],
      Comments: [{
        value: this.supplierBank ? this.supplierBank.Comments : null,
        disabled: this.initialData.comments.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.comments.permission)
      }],
      AccountNumber: [{
        value: this.supplierBank && this.supplierBank.Last4AccountNumber ? `****${this.supplierBank.Last4AccountNumber}` : null,
        disabled: this.initialData.accountNumber.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.accountNumber.permission)
      }],
      IBANCode: [{
        value: this.supplierBank && this.supplierBank.Last4IBANCode ? `****${this.supplierBank.Last4IBANCode}` : null,
        disabled: this.initialData.ibanCode.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.ibanCode.permission)
      }],
      SwiftCode: [{
        value: this.supplierBank ? this.supplierBank.SwiftCode : null,
        disabled: this.initialData.swiftCode.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.swiftCode.permission)
      }],
      RoutingCode: [{
        value: this.supplierBank ? this.supplierBank.ABANumber : null,
        disabled: this.initialData.abaNumber.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.abaNumber.permission)
      }],
      PaymentType: [{
        value: this.supplierBank ? this.supplierBank.PaymentType : null,
        disabled: this.initialData.paymentType.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.paymentType.permission)
      }],
      BankAccountNameKatanaka: [{
        value: this.supplierBank ? this.supplierBank.BankAccountNameKatanaka : null,
        disabled: this.initialData.bankAccountNameKatanaka.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.bankAccountNameKatanaka.permission)
      }],
      BankAccountType: [{
        value: this.supplierBank ? this.supplierBank.BankAccountType : null,
        disabled: this.initialData.bankAccountType.permission !== Permission.ReadWrite && !isNullOrUndefined(this.initialData.bankAccountType.permission)
      }],
      IsNewBankAccount: [this.supplierBank == null || (!this.supplierBank.AccountNumberExists && !this.supplierBank.IBANCodeExists), []],
      IsNewIntermediaryBankAccount: [this.supplierBank == null || !this.supplierBank.IntermediaryBankAccountExists, []],
      IsIntermediaryBanking: [{
        value: this.supplierBank ? this.supplierBank.IsIntermediaryBanking : null,
        disabled: (this.initialData.isIntermediaryBanking.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.isIntermediaryBanking.permission))
      }],
      IntermediaryPaymentOrigin: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryPaymentOrigin : null,
        disabled: this.initialData.intermediaryPaymentOrigin.permission !== Permission.ReadWrite && 
          !isNullOrUndefined(this.initialData.intermediaryPaymentOrigin.permission)
      }],
      IntermediaryBankName: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryBankName : null,
        disabled: (this.initialData.intermediaryBankName.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryBankName.permission))
      }],
      IntermediaryBankRouting: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryBankRouting : null,
        disabled: (this.initialData.intermediaryBankRouting.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryBankRouting.permission))
      }],
      IntermediaryBankSwiftCode: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryBankSwiftCode : null,
        disabled: (this.initialData.intermediaryBankSwiftCode.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryBankSwiftCode.permission))
      }],
      IntermediaryBankAccount: [{
        value: this.supplierBank && this.supplierBank.Last4IntermediaryBankAccount ? `****${this.supplierBank.Last4IntermediaryBankAccount}` : null,
        disabled: (this.initialData.intermediaryBankAccount.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryBankAccount.permission))
      }],
      IntermediaryAddress1: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryAddress1 : null,
        disabled: (this.initialData.intermediaryAddress1.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryAddress1.permission))
      }],
      IntermediaryAddress2: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryAddress2 : null,
        disabled: (this.initialData.intermediaryAddress2.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryAddress2.permission))
      }],
      IntermediaryCity: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryCity : null,
        disabled: (this.initialData.intermediaryCity.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryCity.permission))
      }],
      IntermediaryState: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryState : null,
        disabled: (this.initialData.intermediaryState.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryState.permission))
      }],
      IntermediaryZipCode: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryZipCode : null,
        disabled: (this.initialData.intermediaryZipCode.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryZipCode.permission))
      }],
      IntermediaryCountryCode: [{
        value: this.supplierBank ? this.supplierBank.IntermediaryCountryCode : null,
        disabled: (this.initialData.intermediaryCountryCode.permission !== Permission.ReadWrite &&
          !isNullOrUndefined(this.initialData.intermediaryCountryCode.permission))
      }]
    }, { emitEvent: false });

    this.documentsForm = this.fb.group({
      documents: this.fb.array([], CustomValidator.arrayRequiredValidator)
    });

    if (this.showPaymentOriginControl) {
      this.BankformControls.PaymentOrigin.setValidators([Validators.required]);
    } else {
      this.BankformControls.PaymentOrigin.clearValidators();
    }
    this.BankformControls.PaymentOrigin.updateValueAndValidity();

    if(this.supplierBank){
      if (this.supplierBank?.CountryCode == 'US' || this.supplierBank?.CountryCode == 'USA') {
        this.USAstate = true;
        this.BankformControls.State.setValidators(this.usStateValiator());
        this.BankformControls.State.updateValueAndValidity();
      }else{
        this.USAstate = false;
      }
    }
  }

  ngOnInit() {
    this.languageService.getSelectedLanguageAsync().subscribe(
      res => this.languageSelected = res
    );
    this.documentService.getDocumentType().subscribe(res => {
      this.types = res;
    });

    this.BankformControls.IsIntermediaryBanking.valueChanges
      .subscribe(value => {
        if (value == true) {
          this.showIntermediaryBankingFields = true;
        }
        else {
          this.showIntermediaryBankingFields = false;
        }
        this.resetIntermediaryValidations();
    });
    this.BankformControls.BeneficiaryNameDifferentReason.valueChanges
      .subscribe(value => {
        if (value == "Other, please provide details") {
          this.showNameDifferentReasonComment = true;
          this.BankformControls.BeneficiaryNameDifferentReasonComment.setValidators(Validators.required);
        }
        else {
          this.showNameDifferentReasonComment = false;
        this.BankformControls.BeneficiaryNameDifferentReasonComment.setValue(null);
        this.BankformControls.BeneficiaryNameDifferentReasonComment.clearValidators();
        }
        this.BankformControls.BeneficiaryNameDifferentReasonComment.updateValueAndValidity();
    });
  }

  onBeneficiaryNameEnglishChange(event) {
    const value = event.target.value
    if (this.legalName && this.legalName?.trim() != "") {
      let trimmedLegalName = this.legalName.trim();
      let legalName = trimmedLegalName.length > 35 ? trimmedLegalName.substring(0, 35) : trimmedLegalName;
      let beneName = value ? value?.length > 35 ? value?.trim()?.toLocaleLowerCase()?.substring(0, 35) : value?.trim()?.toLocaleLowerCase() : value;
      if(beneName && beneName != legalName.toLocaleLowerCase()) {
        this.showNameDifferentReason = true;
        this.BankformControls.BeneficiaryNameDifferentReason.setValidators(Validators.required);
      } else {
        this.showNameDifferentReason = false;
        this.BankformControls.BeneficiaryNameDifferentReason.setValue(null);
        this.BankformControls.BeneficiaryNameDifferentReason.clearValidators();
      }
      this.BankformControls.BeneficiaryNameDifferentReason.updateValueAndValidity();
    }
  }

  ngAfterViewInit(): void {
    this.setFormControlsValues();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.bankConfiguration) {
      this.bankConfiguration = changes.bankConfiguration.currentValue;
      this.onBankConfigurationChange();
    }

    if (this.isUSACountry()) {
      this.BankformControls.State.setValidators(this.usStateValiator());
      this.BankformControls.IntermediaryState.setValidators(this.usStateValiator());
    }
    else { 
      this.BankformControls.State.setValidators([]);
      this.BankformControls.IntermediaryState.setValidators([]);
    }
      
    if (changes.supplierBank) {
      this.supplierBank = changes.supplierBank.currentValue;
      this.setFormControlsValues();
      if (this.supplierBank?.CountryCode) {
        this.onCountryChangedEvent.emit({ countryCode: this.supplierBank.CountryCode });
      }
      if (this.supplierBank?.PaymentOrigin) {
        this.onPaymentOriginChangedEvent.emit({ paymentOrigin: this.supplierBank.PaymentOrigin.toString() });
      }
    }

    if (changes.readOnly) {
      //  Enable/Disable controls
      //  Required to use setTimeout due to issue when disabling controls in ngInit
      //  See for more: github.com/angular/angular/issues/22556
      setTimeout(() => this.enableControls(), 500);
    }
  }

  onCountryChanged(countryCode: string) {
    if (countryCode == 'US' || countryCode == 'USA') {
      this.USAstate = true;
    }
    else { 
      this.USAstate = false;
    }
    this.isChina = countryCode == 'CN'
    this.onCountryChangedEvent.emit({ countryCode });
    if (this.isPlaidEnabled())
      this.triggerPlaidAddAccount(countryCode);
  }

  isPlaidEnabled() {
    if (this.supplierBank?.Last4AccountNumber) {
      return this.supplierBank.VerificationStatus;
    }

    const countryCode = this.countryAutocomplete?.selectedValue || this.countryAutocomplete?.formControl?.value || this.supplierBank?.CountryCode;
    const selectedCountry = this.countries.find(x => x.abbreviation == countryCode);
    return selectedCountry && selectedCountry.enablePlaid;
  }

  onPaymentOriginChanged(paymentOrigin: string) {
    this.onPaymentOriginChangedEvent.emit({ paymentOrigin: paymentOrigin });
  }

  onCurrencyChanged(currencyCode: string) {
  }

  /*Hard coding currency to USD for now. it can change for other other countries. probably we have to use default currency for each country*/
  public triggerPlaidAddAccount(countryCode: string, currencyCode: string = 'USD') {
    countryCode = this.countryAutocomplete?.selectedValue || this.countryAutocomplete?.formControl?.value;
    if (!countryCode || !currencyCode)
      return;

    // fetch a signed order token from your backend
    this.bankService.signIn(this.supplierCode, countryCode, currencyCode)
      .subscribe((signedToken: string) => {
        if (!signedToken) {
          this.toaster.error('Something went wrong!');
          return;
        }

        const args = this.bankService.getAddAccountArgs(countryCode, currencyCode, signedToken)
        return this.payoutRefAngular.addAccount(args)
          .then((res: AddAccountResult) => {
            if (res.decision == 'ACCEPT' || res.decision == 'PENDING') {
              this.bankService.fetchBankMetaData(this.supplierCode).subscribe(bank => {
                if (bank) {
                  if (bank.VerificationStatus == VerificationStatus.PendingDeposit) {
                    this.BankformControls.RoutingCode.setValue('*******');
                    this.BankformControls.RoutingCode.disable();
                    this.BankformControls.RoutingCode.updateValueAndValidity();
                  }

                  if (bank.Last4AccountNumber) {
                    this.BankformControls.AccountNumber.setValue('****' + bank.Last4AccountNumber);
                    this.BankformControls.AccountNumber.disable();
                    this.BankformControls.AccountNumber.updateValueAndValidity();
                    this.supplierBank.Last4AccountNumber = bank.Last4AccountNumber;

                    this.BankformControls.IsNewBankAccount.setValue(true);
                    this.BankformControls.IsNewBankAccount.updateValueAndValidity();

                    this.toaster.success('Successfully linked the account!');
                  }
                  if (bank.ABANumber) {
                    this.BankformControls.RoutingCode.setValue(bank.ABANumber);
                    this.BankformControls.RoutingCode.disable();
                    this.BankformControls.RoutingCode.updateValueAndValidity();
                  }
                  if (bank.BankName) {
                    this.BankformControls.Name.setValue(bank.BankName);
                    this.BankformControls.Name.disable();
                    this.BankformControls.Name.updateValueAndValidity();
                    if (!this.supplierBank?.BankNickName) {
                      this.BankformControls.NickName.setValue(bank.BankName);
                      this.BankformControls.NickName.updateValueAndValidity();
                    }
                  }

                  if (bank.CurrencyCode && !this.supplierBank?.CurrencyCode) {
                    this.currecyAutocomplete.setValue(bank.CurrencyCode);
                    this.BankformControls.Currency.updateValueAndValidity();
                  }

                  if (bank.PaymentOrigin && !this.supplierBank?.PaymentOrigin && this.showPaymentOriginControl) {
                    this.BankformControls.PaymentOrigin.setValue(bank.PaymentOrigin, { emitEvent: false });
                    this.BankformControls.PaymentOrigin.updateValueAndValidity();
                    this.onPaymentOriginChangedEvent.emit({ paymentOrigin: bank.PaymentOrigin });
                  }

                  this.supplierBank.VerificationStatus = bank.VerificationStatus;
                  this.supplierBank.VerificationTransactionId = res.transactionNumber;
                }
              },
                (error) => {
                  console.error(error);
                  this.toaster.error('Something went wrong!');
                });
            } else {
              console.error(res);
              this.toaster.error('Something went wrong!');
            }
          })
          .catch(ex => {
            console.error(ex);
            this.toaster.error('Something went wrong!');
          })
      })
  }

  verify() {
    this.onVerifyEvent.emit({ supplierBank: this.supplierBank });
  }

  resetIntermediaryValidations() {
    this.showIntermediaryBankingFields == true ? this.BankformControls.IntermediaryPaymentOrigin.setValidators(Validators.required) : this.BankformControls.IntermediaryPaymentOrigin.clearValidators();
    this.showIntermediaryBankingFields == true ? this.BankformControls.IntermediaryBankName.setValidators(Validators.required) : this.BankformControls.IntermediaryBankName.clearValidators();
    this.showIntermediaryBankingFields == true ? this.BankformControls.IntermediaryBankRouting.setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')]) : this.BankformControls.IntermediaryBankRouting.clearValidators();
    this.showIntermediaryBankingFields == true ? this.BankformControls.IntermediaryBankSwiftCode.setValidators([Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')]) : this.BankformControls.IntermediaryBankSwiftCode.clearValidators();
    this.BankformControls.IntermediaryPaymentOrigin.updateValueAndValidity();
    this.BankformControls.IntermediaryBankName.updateValueAndValidity();
    this.BankformControls.IntermediaryBankRouting.updateValueAndValidity();
    this.BankformControls.IntermediaryBankSwiftCode.updateValueAndValidity();
  }

  saveDraft(bank: SupplierBank) {
    this.onSaveEvent.emit({ supplierBank: bank });
  }

  /** Gets object with all the controls of the bank form group */
  get BankformControls() {
    return {
      Country: this.bankForm.get('Country'),
      PaymentOrigin: this.bankForm.get('PaymentOrigin'),
      Currency: this.bankForm.get('Currency'),
      NickName: this.bankForm.get('NickName'),
      Name: this.bankForm.get('Name'),
      BankLocalName: this.bankForm.get('BankLocalName'),
      AccountNumber: this.bankForm.get('AccountNumber'),
      RoutingCode: this.bankForm.get('RoutingCode'),
      IBANCode: this.bankForm.get('IBANCode'),
      SwiftCode: this.bankForm.get('SwiftCode'),
      PaymentType: this.bankForm.get('PaymentType'),
      Address1: this.bankForm.get('Address1'),
      Address2: this.bankForm.get('Address2'),
      City: this.bankForm.get('City'),
      State: this.bankForm.get('State'),
      ZipCode: this.bankForm.get('ZipCode'),
      Comments: this.bankForm.get('Comments'),
      BankAccountNameKatanaka: this.bankForm.get('BankAccountNameKatanaka'),
      BankAccountType: this.bankForm.get('BankAccountType'),
      BeneficiaryNameEnglish: this.bankForm.get('BeneficiaryNameEnglish'),
      BeneficiaryNameDifferentReason: this.bankForm.get('BeneficiaryNameDifferentReason'),
      BeneficiaryNameDifferentReasonComment: this.bankForm.get('BeneficiaryNameDifferentReasonComment'),
      BeneficiaryNameLocal: this.bankForm.get('BeneficiaryNameLocal'),
      IsNewBankAccount: this.bankForm.get('IsNewBankAccount'),
      IsNewIntermediaryBankAccount: this.bankForm.get('IsNewIntermediaryBankAccount'),
      IsIntermediaryBanking: this.bankForm.get('IsIntermediaryBanking'),
      IntermediaryPaymentOrigin: this.bankForm.get('IntermediaryPaymentOrigin'),
      IntermediaryBankName: this.bankForm.get('IntermediaryBankName'),
      IntermediaryBankRouting: this.bankForm.get('IntermediaryBankRouting'),
      IntermediaryBankSwiftCode: this.bankForm.get('IntermediaryBankSwiftCode'),
      IntermediaryBankAccount: this.bankForm.get('IntermediaryBankAccount'),
      IntermediaryAddress1: this.bankForm.get('IntermediaryAddress1'),
      IntermediaryAddress2: this.bankForm.get('IntermediaryAddress2'),
      IntermediaryCity: this.bankForm.get('IntermediaryCity'),
      IntermediaryState: this.bankForm.get('IntermediaryState'),
      IntermediaryZipCode: this.bankForm.get('IntermediaryZipCode'),
      IntermediaryCountryCode: this.bankForm.get('IntermediaryCountryCode')
    };
  }

  /** Set bank form values from provided supplier bank details */
  setFormControlsValues() {
    const controls = this.BankformControls;
    controls.Country.setValue(this.supplierBank?.CountryCode || '', { emitEvent: false });
    if (this.showPaymentOriginControl) {
      controls.PaymentOrigin.setValue(this.supplierBank?.PaymentOrigin || '', { emitEvent: false });
      controls.PaymentOrigin.setValidators([Validators.required]);
    }
    controls.Currency.setValue(this.supplierBank?.CurrencyCode || '', { emitEvent: false });
    controls.NickName.setValue(this.supplierBank?.BankNickName || '', { emitEvent: false });
    controls.Name.setValue(this.supplierBank?.BankName || '', { emitEvent: false });
    controls.AccountNumber.setValue(this.supplierBank?.Last4AccountNumber ? `****${this.supplierBank.Last4AccountNumber}` : '', { emitEvent: false });
    controls.RoutingCode.setValue(this.supplierBank?.ABANumber || '', { emitEvent: false });
    controls.IBANCode.setValue(this.supplierBank?.Last4IBANCode ? `****${this.supplierBank.Last4IBANCode}` : '', { emitEvent: false });
    controls.BankLocalName.setValue(this.supplierBank?.BankLocalName || '', { emitEvent: false });
    controls.SwiftCode.setValue(this.supplierBank?.SwiftCode || '', { emitEvent: false });
    controls.PaymentType.setValue(this.supplierBank?.PaymentType || '', { emitEvent: false });
    controls.BankAccountType.setValue(this.supplierBank?.BankAccountType || '', { emitEvent: false });
    controls.Address1.setValue(this.supplierBank?.Address1 || '', { emitEvent: false });
    controls.Address2.setValue(this.supplierBank?.Address2 || '', { emitEvent: false });
    controls.City.setValue(this.supplierBank?.City || '', { emitEvent: false });
    controls.State.setValue(this.supplierBank?.State || '', { emitEvent: false });
    controls.ZipCode.setValue(this.supplierBank?.ZipCode || '', { emitEvent: false });
    controls.Comments.setValue(this.supplierBank?.Comments || '', { emitEvent: false });
    controls.BankAccountNameKatanaka.setValue(this.supplierBank?.BankAccountNameKatanaka || '', { emitEvent: false });
    controls.BeneficiaryNameEnglish.setValue(this.supplierBank?.BeneficiaryNameEnglish || '', { emitEvent: false });
    controls.BeneficiaryNameDifferentReason.setValue(this.supplierBank?.BeneficiaryNameDifferentReason || '', { emitEvent: false });
    controls.BeneficiaryNameDifferentReasonComment.setValue(this.supplierBank?.BeneficiaryNameDifferentReasonComment || '', { emitEvent: false });
    controls.BeneficiaryNameLocal.setValue(this.supplierBank?.BeneficiaryNameLocal || '', { emitEvent: false });
    this.onBeneficiaryNameEnglishChange({target: {value: this.supplierBank?.BeneficiaryNameEnglish}});

    // set Intermediary fields
    this.showIntermediaryBankingFields = this.supplierBank?.IsIntermediaryBanking;
    controls.IsIntermediaryBanking.setValue(this.supplierBank?.IsIntermediaryBanking || false, { emitEvent: false });
    controls.IntermediaryPaymentOrigin.setValue(this.supplierBank?.IntermediaryPaymentOrigin || '', { emitEvent: false });
    controls.IntermediaryBankName.setValue(this.supplierBank?.IntermediaryBankName || '', { emitEvent: false });
    controls.IntermediaryBankRouting.setValue(this.supplierBank?.IntermediaryBankRouting || '', { emitEvent: false });
    controls.IntermediaryBankSwiftCode.setValue(this.supplierBank?.IntermediaryBankSwiftCode || '', { emitEvent: false });
    controls.IntermediaryCountryCode.setValue(this.supplierBank?.IntermediaryCountryCode || '', { emitEvent: false });
    controls.IntermediaryAddress1.setValue(this.supplierBank?.IntermediaryAddress1 || '', { emitEvent: false });
    controls.IntermediaryAddress2.setValue(this.supplierBank?.IntermediaryAddress2 || '', { emitEvent: false });
    controls.IntermediaryCity.setValue(this.supplierBank?.IntermediaryCity || '', { emitEvent: false });
    controls.IntermediaryState.setValue(this.supplierBank?.IntermediaryState || '', { emitEvent: false });
    controls.IntermediaryZipCode.setValue(this.supplierBank?.IntermediaryZipCode || '', { emitEvent: false });
    controls.IntermediaryBankAccount.setValue(this.supplierBank?.Last4IntermediaryBankAccount ? `****${this.supplierBank.Last4IntermediaryBankAccount}` : '', { emitEvent: false })
    controls.IsNewBankAccount.setValue(this.supplierBank == null || (!this.supplierBank.AccountNumberExists && !this.supplierBank.IBANCodeExists), { emitEvent: false });
    controls.IsNewIntermediaryBankAccount.setValue(this.supplierBank == null || !this.supplierBank.IntermediaryBankAccountExists, { emitEvent: false });

    if (this.supplierBank && this.supplierBank.DocumentInfos && this.supplierBank.DocumentInfos.length > 0 && this.supplierBank?.DocumentInfos?.filter(d => (d.ID == null || d.ID == undefined) && d.FileName?.length > 0)?.length > 0) {
      this.documentsForm = this.fb.group({
        documents: this.fb.array(this.supplierBank.DocumentInfos.map(docInfo => {
          if(!docInfo) return;
          if(docInfo?.ID) return;
          let documentGroup = this.fb.group({
            documentId: [docInfo.DocumentID, null],
            fileName: [docInfo.FileName, Validators.required],
            attachment: [],
            effectiveDate: [docInfo.EffectiveDate, Validators.required],
            expirationDate: [null, null],
            signDate: [null, null]
          });
          documentGroup.setValidators(Validators.required);
          documentGroup.updateValueAndValidity({ emitEvent: false });
          return documentGroup;
        }), CustomValidator.arrayRequiredValidator)
      });
    } else {
      this.documentsForm = this.fb.group({
        documents: this.fb.array([], CustomValidator.arrayRequiredValidator)
      });
    }

    //  Set the boolean flags for senstive fields
    this.isAccountNumberEdited = this.supplierBank ? !this.supplierBank.AccountNumberExists : false;
    this.isIBANEdited = this.supplierBank ? !this.supplierBank.IBANCodeExists : false;
    this.isIntermediaryAccountNumberEdited = this.supplierBank ? (isNullOrUndefined(this.supplierBank.Last4IntermediaryBankAccount)) : false;

    //  Save the account and iban numbers
    this.originalAccountNumber = this.supplierBank && this.supplierBank.AccountNumber ? this.supplierBank.AccountNumber : '';
    this.originalIbanNumber = this.supplierBank && this.supplierBank.IBANCode;

    //  Set country and currency values
    this.countryAutocomplete?.setValue(this.supplierBank?.CountryCode);
    this.paymentOriginAutocomplete?.setValue(this.supplierBank?.PaymentOrigin);
    this.currecyAutocomplete?.setValue(this.supplierBank?.CurrencyCode);
    if (this.supplierBank?.IntermediaryCountryCode) {
      setTimeout(() => {
        this.intermCountryAutocomplete?.setValue(this.supplierBank?.IntermediaryCountryCode)
        this.BankformControls.IntermediaryCountryCode.setValidators([this.CountryAutoCompleteValidator(this.BankformControls.IntermediaryCountryCode, this.intermCountryAutocomplete, 'CountryAutoCompleteError')]);
      }, 500);
    }

    if (this.currecyAutocomplete && this.currencies) {
      this.BankformControls.Currency.setValidators([Validators.required, this.CurrencyAutoCompleteValidator(this.BankformControls.Currency, this.currecyAutocomplete, 'CurrencyAutoCompleteError')]);
    }

    if (this.currecyAutocomplete && this.countries) {
      this.BankformControls.Country.setValidators([Validators.required, this.CountryAutoCompleteValidator(this.BankformControls.Country, this.countryAutocomplete, 'CountryAutoCompleteError')]);
    }

    this.resetIntermediaryValidations();

    //  Enable/Disable controls
    //  Required to use setTimeout due to issue when disabling controls in ngInit
    //  See for more: github.com/angular/angular/issues/22556
    setTimeout(() => this.enableControls(), 500);
  }

  /** Enables or disables address controls */
  private enableControls() {
    let controls = this.bankForm.controls;

    if (this.readOnly) {
      Object.keys(controls).forEach(key => controls[key].disable({ emitEvent: false }));
      this.documents.controls.forEach(key => key.disable({ emitEvent: false }))
    } else {
      Object.keys(controls).forEach(key => controls[key].enable({ emitEvent: false }));
      this.documents.controls.forEach(key => key.enable({ emitEvent: false }))
      this.disableAutoPopulatedFields();
      this.disableSensitiveFields();
      this.disableImportantFields();
    }
  }

  download(doc: FormGroup) {
    let documentId = doc.get('documentId')?.value;
    let documentName = doc.get('fileName')?.value;
    let file = doc.get('attachment')?.value;
    this.downloadDocument(documentId, null, documentName, file)
  }

  /** Downloads file document */
  public downloadDocument(documentId: string, version: string, fileName: string, file: File) {
    if (!isNullOrUndefined(documentId)) {
      this.onboardingDocumentsService.downloadDocument(documentId, this.supplierCode, version).subscribe(resultBlob => {
        FileSaver.saveAs(resultBlob, fileName || documentId);
      });
    } else {
      if (!isNullOrUndefined(file)) {
        FileSaver.saveAs(file, fileName || documentId);
      }
    }
  }

  disableSensitiveFields() {
    if (this.supplierBank && this.supplierBank?.Last4AccountNumber) {
      this.BankformControls.AccountNumber.disable();
    }
    if (this.supplierBank && this.supplierBank?.Last4IntermediaryBankAccount) {
      this.BankformControls.IntermediaryBankAccount.disable();
    }
    if (this.supplierBank && this.supplierBank?.Last4IBANCode) {
      this.BankformControls.IBANCode.disable();
    }
    if (this.supplierBank && this.supplierBank?.ID) {
      this.BankformControls.NickName.disable();
    }
  }

  disableImportantFields() {
    if (this.supplierBank && this.supplierBank?.CountryCode && this.supplierBank?.ID) {
      this.BankformControls.Country.disable();
    }
  }

  disableAutoPopulatedFields() {
    if (this.supplierBank && this.isPlaidEnabled()) {
      this.BankformControls.Name.disable();
      this.BankformControls.AccountNumber.disable();
      this.BankformControls.RoutingCode.disable();
    } else {
      this.BankformControls.Name.enable();
      this.BankformControls.AccountNumber.enable();
      this.BankformControls.RoutingCode.enable();
    }

    this.BankformControls.Name.updateValueAndValidity();
    this.BankformControls.AccountNumber.updateValueAndValidity();
    this.BankformControls.RoutingCode.updateValueAndValidity();
  }

  /** Click envent hanlder of the cancel button */
  onCancel() {
    //  Trigger on cancel event
    this.onCancelEvent.emit();
  }

  /** Validates all form groups and triggers on submit event if they are all valid */
  onSubmit(isPartialSave?: boolean) {
    let partialSaveValid = false;
    let skipDocumentValidation = this.skipBankDocumentValidation();
    if (this.isSupplierTask) {
      if (!isPartialSave && this.supplierBank?.VerificationStatus?.toLowerCase().includes('pending')) {
        this.onErrorEvent.emit({ errorMessage: this.translate.get('Please confirm microdeposits.') });
        return
      }
      if (isPartialSave && this.bankForm && !this.bankForm.valid) {
        partialSaveValid = true;
        for (const fieldName in this.bankForm.controls) {
          if (this.bankForm.controls[fieldName].invalid) {
            if (this.bankForm.controls[fieldName].errors) {
              for (const error in this.bankForm.controls[fieldName].errors) {
                if (error != 'required') {
                  partialSaveValid = false;
                  break;
                }
              }
              if (!partialSaveValid) break;
            }
          }
        };
      }
    }
    if (this.bankForm.valid || partialSaveValid) {
      if (!skipDocumentValidation && (!this.hideDocumentSection && !isPartialSave && !this.documentsForm.valid)) {
        //  Trigger failure submit event
        this.toaster.error(this.translate.get('Bank document is required'));
        return;
      }

      //  Create bank object and map data from form fields
      let supplierBank = new SupplierBank();
      let controls = this.BankformControls;

      if(this.supplierBank?.ID) {
        supplierBank.Operation = OPERATION.UPDATE;
        supplierBank.ID = this.supplierBank.ID
      } else supplierBank.Operation = OPERATION.CREATE;
      supplierBank.CountryCode = this.countryAutocomplete.selectedValue;

      

      // As Payment origin is a conditional field, add only if it exists
      if (this.showPaymentOriginControl)
        supplierBank.PaymentOrigin = this.paymentOriginAutocomplete.selectedValue || this.paymentOriginAutocomplete.formControl.value;
      supplierBank.CurrencyCode = this.currecyAutocomplete.selectedValue;
      supplierBank.BankName = controls.Name.value;
      supplierBank.BankLocalName = controls.BankLocalName.value;
      supplierBank.BankNickName = controls.NickName.value;
      supplierBank.BeneficiaryNameEnglish = controls.BeneficiaryNameEnglish.value;
      supplierBank.BeneficiaryNameDifferentReason = controls.BeneficiaryNameDifferentReason.value;
      supplierBank.BeneficiaryNameDifferentReasonComment = controls.BeneficiaryNameDifferentReasonComment.value;
      supplierBank.BeneficiaryNameLocal = controls.BeneficiaryNameLocal.value;
      supplierBank.SwiftCode = controls.SwiftCode.value;
      supplierBank.PaymentType = controls.PaymentType.value;
      supplierBank.BankAccountNameKatanaka = controls.BankAccountNameKatanaka.value;
      supplierBank.BankAccountType = controls.BankAccountType.value;
      supplierBank.Address1 = controls.Address1.value;
      supplierBank.Address2 = controls.Address2.value;
      supplierBank.City = controls.City.value;
      supplierBank.State = controls.State.value;
      supplierBank.ZipCode = controls.ZipCode.value;
      supplierBank.Comments = controls.Comments.value;
      supplierBank.ABANumber = controls.RoutingCode.value;
      if(this.supplierBank.TempID) supplierBank.IsNewBankAccount = this.supplierBank.IsNewBankAccount;
      else supplierBank.IsNewBankAccount = this.BankformControls.IsNewBankAccount.value;
      supplierBank.AccountNumberExists = this.supplierBank && this.supplierBank.AccountNumberExists;
      supplierBank.IBANCodeExists = this.supplierBank && this.supplierBank.IBANCodeExists;
      supplierBank.SkipDocumentValidation = skipDocumentValidation;
      if(this.supplierBank.IsModified == null || this.supplierBank.IsModified == false){
        supplierBank.IsModified = this.bankForm.dirty;
      }

      if (supplierBank.IsNewBankAccount) {
        if(this.supplierBank.TempID) {
          supplierBank.AccountNumber = this.originalAccountNumber;
          supplierBank.IBANCode = this.originalIbanNumber;
          supplierBank.Last4AccountNumber = this.supplierBank?.Last4AccountNumber;
          supplierBank.Last4IBANCode = this.supplierBank?.Last4IBANCode;
        } else {
          supplierBank.AccountNumber = controls.AccountNumber.value;
          supplierBank.IBANCode = controls.IBANCode.value;
          supplierBank.Last4AccountNumber = controls.AccountNumber.value ? controls.AccountNumber.value.substr(controls.AccountNumber.value.length - 4) : null;
          supplierBank.Last4IBANCode = controls.IBANCode.value ? controls.IBANCode.value.substr(controls.IBANCode.value.length - 4) : null;
        }
      } else {
        supplierBank.AccountNumber = this.originalAccountNumber;
        supplierBank.IBANCode = this.originalIbanNumber;
        supplierBank.Last4AccountNumber = this.supplierBank?.Last4AccountNumber;
        supplierBank.Last4IBANCode = this.supplierBank?.Last4IBANCode;
      }

      // set Intermediary fields
      supplierBank.IsIntermediaryBanking = this.BankformControls.IsIntermediaryBanking.value == true ? true : false;
      supplierBank.IntermediaryPaymentOrigin = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryPaymentOrigin.value : null;
      supplierBank.IntermediaryBankName = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryBankName.value : null;
      supplierBank.IntermediaryBankRouting = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryBankRouting.value : null;
      supplierBank.IntermediaryBankSwiftCode = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryBankSwiftCode.value : null;
      supplierBank.IntermediaryBankAccount = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryBankAccount.value : null;
      supplierBank.IntermediaryCountryCode = supplierBank.IsIntermediaryBanking == true ? this.intermCountryAutocomplete.selectedValue : null;
      supplierBank.IntermediaryZipCode = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryZipCode.value : null;
      supplierBank.IntermediaryCity = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryCity.value : null;
      supplierBank.IntermediaryState = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryState.value : null;
      supplierBank.IntermediaryAddress1 = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryAddress1.value : null;
      supplierBank.IntermediaryAddress2 = supplierBank.IsIntermediaryBanking == true ? this.BankformControls.IntermediaryAddress2.value : null;
      supplierBank.IsNewIntermediaryBankAccount = this.BankformControls.IsNewIntermediaryBankAccount.value;
      supplierBank.StageID = this.supplierBank?.StageID || null;
      
      //  Map documents to upload file model
      let uploadFiles: BankUploadFileModel[] = this.documents.controls.map(doc => {
        let fileData = doc.get('attachment') ? doc.get('attachment').value as File : null;
        let effectiveDateControl = doc.get('effectiveDate') as FormControl;
        let expireDateControl = doc.get('expirationDate') as FormControl;
        if (fileData) {
          return { supplierDocument: null, fileData, effectiveDateControl, expireDateControl };
        } else {
          let supplierDocument = {
            DocumentID: doc.get('documentId') ? doc.get('documentId').value : null,
            FileName: doc.get('fileName') ? doc.get('fileName').value : null,
            EffectiveDate: effectiveDateControl ? effectiveDateControl.value : null,
            ExpiryDate: expireDateControl ? expireDateControl.value : null,
            DocumentVersion: '1',
          } as SupplierDocument;
          return { supplierDocument, fileData: null, effectiveDateControl, expireDateControl };
        }
      });

      supplierBank.VerificationStatus = this.supplierBank.VerificationStatus;
      supplierBank.VerificationTransactionId = this.supplierBank.VerificationTransactionId;

      var isBankDataChanged = this.checkIfBankDataIsChanged(uploadFiles);

      //  Trigger successful submit event
      this.onSubmitEvent.emit({ supplierBank, uploadFiles, isPartialSave, isBankDataChanged });
    } else {
      //  Trigger failure submit event
      if(isPartialSave) this.onErrorEvent.emit({ errorMessage: this.translate.get('Please provide valid value for entered fields.') });
      else this.onErrorEvent.emit({ errorMessage: this.translate.get('Bank fields are incomplete.') });
      validateAllFormFields(this.bankForm);
    }
  }

  skipBankDocumentValidation(){
    let skipDocumentValidation = false;
    if(this.enableDocumentSectionValidationBasedOnFieldModification && (this.supplierBank.IsModified == null || this.supplierBank.IsModified == false)) {
      skipDocumentValidation = !(this.bankForm.dirty);
      if(this.supplierBank?.ID != undefined && this.supplierBank?.ID != null && this.supplierBank?.ID > 0 && skipDocumentValidation == true)
      {
        // If no document is associated with the bank Id and no document has been uploaded than we will mandate the doc
        if((this.requiredBankDocuments == undefined || this.requiredBankDocuments == null || this.requiredBankDocuments.AssociatedCategoryLinkId == undefined || this.requiredBankDocuments.AssociatedCategoryLinkId == null) || ((this.requiredBankDocuments?.AssociatedCategoryLinkId?.includes(this.supplierBank?.ID.toString()) === false) && ((this.documents?.value == undefined || this.documents?.value == null || this.documents?.value?.length == 0 || this.documents?.value?.[0]?.fileName == null))))
        {
          skipDocumentValidation = false;
        }
      }
    }

    return skipDocumentValidation;
  }

  checkIfBankDataIsChanged(uploadFiles: BankUploadFileModel[]): boolean
  {
    var isBankDataChanged = false;
    console.log('SupplierBank', this.supplierBank);

    if(this.supplierRequestType != undefined && !isNullOrEmpty(this.supplierRequestType) && this.supplierRequestType.toLowerCase() != "NameOrTINChange".toLowerCase())
    {
      return false;
    }

    var skipBankKeys = ['AccountNumber'];
    
    this.supplierBankKeyMap.forEach((currentBankKey) => {
      if(skipBankKeys.includes(currentBankKey.SupplierBankKey) == false)
      {
        //console.log(currentBankKey?.SupplierBankKey + ' ---- ' + this.supplierBank[currentBankKey?.SupplierBankKey] + ' | ' + eval(currentBankKey?.SupplierBankControlKey) )
        if(currentBankKey?.IsConditional == true)
        {
          //console.log('Condition' + ' ---- ' + currentBankKey?.ConditionValue + ' | ' + eval(currentBankKey?.ConditionValue) );
          if(eval(currentBankKey?.ConditionValue))
          {
            if(currentBankKey?.SupplierBankControlKeyList?.length > 0)
            {
              if(this.supplierBank[currentBankKey?.SupplierBankKey] != undefined &&  eval(currentBankKey?.SupplierBankControlKeyList) != undefined && this.supplierBank[currentBankKey?.SupplierBankKey] != eval(currentBankKey?.SupplierBankControlKeyList))
              {
                //console.log('Change detected for - ',currentBankKey?.SupplierBankKey);
                isBankDataChanged = true;
              }
            }
            else
            {
              if(this.supplierBank[currentBankKey.SupplierBankKey] != undefined && eval(currentBankKey?.SupplierBankControlKey) != undefined && this.supplierBank[currentBankKey?.SupplierBankKey] != eval(currentBankKey?.SupplierBankControlKey))
              {
                //console.log('Change detected for - ',currentBankKey?.SupplierBankKey);
                isBankDataChanged = true;
              }
            }
          }
        }
        else
        {
          if(this.supplierBank[currentBankKey.SupplierBankKey] != undefined && eval(currentBankKey?.SupplierBankControlKey) != undefined && this.supplierBank[currentBankKey?.SupplierBankKey] != eval(currentBankKey?.SupplierBankControlKey))
          {
            //console.log('Change detected for - ',currentBankKey?.SupplierBankKey);
            isBankDataChanged = true;
          }
        }
      }
    })

    if(uploadFiles != undefined && uploadFiles != null && uploadFiles?.length > 0)
    {
      //console.log('Change detected for Documennts',uploadFiles);
      isBankDataChanged = true;
    }

    console.log('Is Data Changed ',isBankDataChanged);
    return isBankDataChanged;
  }

  valiateIban() {
    var input = this.BankformControls.IBANCode.value;
    var country = this.countryAutocomplete.selectedValue;
    var payload = { CountryCode: country, Iban: input };
    this.bankService.validateIban(this.supplierCode, payload).subscribe(result => {
      if (result || result.length != 0) {
          this.errors = result;
      }
    })
  }

  /** Updates the controls whenever the bank configuration input changes */
  private onBankConfigurationChange(clearValues: boolean = false) {
    if (this.bankConfiguration) {
      const keys = Object.keys(this.bankConfiguration);
      keys.forEach(key => {
        const config: BankConfig = this.bankConfiguration[key];
        const controlName = this.bankConfigControlMap[key];
        var control = this.BankformControls[controlName] as FormControl;
        if (clearValues)
          control.setValue(null, { emitEvent: false });
        if (config && this.showControl(config.required)) {

          if (key == 'accountNumber') {
            if (this.isAccountNumberEdited) {
              control.setValidators(
                this.getControlValidators(config.required,
                  config.minSize,
                  config.maxSize,
                  config.type,
                  key
                )
              );
            }
          } else if (key == 'iban') {
            if (this.isIBANEdited) {
              control.setValidators(
                this.getControlValidators(config.required,
                  config.minSize,
                  config.maxSize,
                  config.type,
                  key
                )
              );
            }
          } else {
            control.setValidators(
              this.getControlValidators(config.required,
                config.minSize,
                config.maxSize,
                config.type,
                key
              )
            );
          }

        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity({ emitEvent: false });
      });

      if(this.isUSACountry()){
        this.BankformControls.State.setValidators(this.usStateValiator());
        this.BankformControls.State.updateValueAndValidity();
      }

      this.refreshD365FieldValidation();
    }
  }

  refreshD365FieldValidation() {
    let controls = this.BankformControls;
    controls.AccountNumber.updateValueAndValidity({ emitEvent: false });
    controls.IBANCode.updateValueAndValidity({ emitEvent: false });
    controls.SwiftCode.updateValueAndValidity({ emitEvent: false });
    controls.RoutingCode.updateValueAndValidity({ emitEvent: false });
    controls.PaymentType.updateValueAndValidity({ emitEvent: false });
    controls.Address1.updateValueAndValidity({ emitEvent: false });
    controls.Address2.updateValueAndValidity({ emitEvent: false });
    controls.City.updateValueAndValidity({ emitEvent: false });
    controls.State.updateValueAndValidity({ emitEvent: false });
    controls.City.updateValueAndValidity({ emitEvent: false });
    controls.ZipCode.updateValueAndValidity({ emitEvent: false });

    controls.BankAccountNameKatanaka.updateValueAndValidity({ emitEvent: false });
    controls.BankAccountType.updateValueAndValidity({ emitEvent: false });
  }

  /** Event handler for when a file is added */
  public onFileAdd(newFiles: File[]) {
    if(!newFiles?.length) return;
    newFiles.forEach(file => {
      if (file.size > this.fileSizeLimitMB) {
        this.dialog.alert(this.translate.get('Alert'), this.translate.get('File size can not be more than 10MB!'));
      }
      else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        let documentGroup = this.fb.group({
          documentId: [null, null],
          fileName: [file.name, Validators.required],
          attachment: [file],
          effectiveDate: [null, Validators.required],
          expirationDate: [null, null],
          signDate: [null, null]
        });
        documentGroup.setValidators(Validators.required);
        documentGroup.updateValueAndValidity({ emitEvent: false });
        this.validateFile(documentGroup);
        if (!this.invalidDoc) {
          this.documentsForm.setControl('documents', this.fb.array([documentGroup]));
        }
      }
    });
  }

  private isUSACountry() {
    return this.BankformControls?.Country?.value == "US" || this.BankformControls?.Country?.value == "USA";
  }

  removeFile(index) {
    this.fileDrop.reset(true);
    if (this.documents) {
      this.documents.removeAt(index);
    }

    // if documents are deleted reset the validations
    if(this.documents == null || this.documents.length === 0){
      this.documents.clearValidators();
      this.documents.setValidators([CustomValidator.arrayRequiredValidator]);
      this.documents.updateValueAndValidity();
    }
  }

  fetchDropdownKey(option: any) {
    return option['Key'] || option['key'];
  }

  fetchDropdownValue(option: any) {
    return option['Value'] || option['value'];
  }

  /** Determines if we need to display a control, by providing the required configuration. */
  showControl(requiredConfig: string): boolean {
    return requiredConfig === 'Yes' || requiredConfig === 'Optional';
  }

  /** Gets user friendly validation error messages */
  getValidationMessages(controlName: string, displayName: string, control: FormControl) {
    if (control.dirty || control.touched) {
      if (control.hasError('required')) {
        return this.translate.get(displayName) + ' ' + this.translate.get('is required');
      } else if (this.bankConfiguration) {
        const config: BankConfig = this.bankConfiguration[controlName];
        if (!config) return "Input is not valid";
        if (control.hasError('minlength') || control.hasError('maxlength')) {
          if (config.minSize === config.maxSize) {
            return this.translate.get(displayName) + ' ' + this.translate.get('should be') + ' ' + config.maxSize + ' ' + this.translate.get('characters');
          }
          return this.translate.get(displayName) + ' ' + this.translate.get('should be') + ' ' + this.translate.get('between') + ' ' + config.minSize + ' ' + this.translate.get('and') + ' ' + config.maxSize;
        } else if (control.hasError('pattern') && !isNullOrUndefined(config) && !isNullOrUndefined(config.type)) {
          return this.translate.get(displayName) + ' ' + this.translate.get('should be') + ' ' + config.type.toLowerCase();
        } else if (control.hasError('pattern')) {
          return this.translate.get('Special characters are not allowed')
        }
      } else {
        if (control.hasError('pattern')) {
          return this.translate.get('Spaces and special characters are not allowed')
        }
      }
    }
  }

  editIBanCode() {
    let ibanControl = this.BankformControls.IBANCode;
    this.isIBANEdited = true;
    this.BankformControls.IsNewBankAccount.setValue(true);
    ibanControl.setValue(null);
    ibanControl.enable();
    ibanControl.clearValidators();
    const config: BankConfig = this.bankConfiguration.iban;
    ibanControl.setValidators(
      this.getControlValidators(config.required,
        config.minSize,
        config.maxSize,
        config.type,
        'iban'
      )
    );
    ibanControl.updateValueAndValidity({ emitEvent: false });
  }

  editAccountNumber() {
    let bankControl = this.BankformControls.AccountNumber;
    this.isAccountNumberEdited = true;
    this.BankformControls.IsNewBankAccount.setValue(true, { emitEvent: false });
    bankControl.setValue(null, { emitEvent: false });
    bankControl.enable({ emitEvent: false });
    bankControl.clearValidators();
    const config: BankConfig = this.bankConfiguration.accountNumber;
    bankControl.setValidators(
      this.getControlValidators(config.required,
        config.minSize,
        config.maxSize,
        config.type,
        'accountNumber'
      )
    );
    bankControl.updateValueAndValidity({ emitEvent: false });
  }

  editIntermediaryAccountNumber() {
    let bankControl = this.BankformControls.IntermediaryBankAccount;
    this.isIntermediaryAccountNumberEdited = true;
    this.BankformControls.IsNewIntermediaryBankAccount.setValue(true, { emitEvent: false });
    bankControl.setValue(null, { emitEvent: false });
    bankControl.enable({ emitEvent: false });
    bankControl.clearValidators();
    bankControl.updateValueAndValidity({ emitEvent: false });
  }

  /** Gets array of validaros depending on the configuration of the field */
  getControlValidators(requiredData: string, minLength: number, maxLength: number, type: string, key: string): any[] {
    const customValidators: any[] = [];
    if (requiredData === 'Yes') {
      customValidators.push(Validators.required);
    }

    if (minLength) {
      customValidators.push(Validators.minLength(minLength));
    }
    if (maxLength) {
      customValidators.push(Validators.maxLength(maxLength));
    }

    if (key === 'beneficiaryNameEnglish') {
      customValidators.push(Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$'));
    }
    if (key === 'iban') {
      customValidators.push(Validators.pattern('^([0-9a-zA-Z*])+$'));
    }
    if (type && type.toLowerCase() === 'numeric') {
      customValidators.push(Validators.pattern('^[0-9]+$'));
    } else if (type && type.toLowerCase() === 'alphanumeric' && key === 'accountNumber') {
      customValidators.push(Validators.pattern('^[a-zA-Z0-9-_]+$'));
    } else if (type && type.toLowerCase() === 'alphanumeric') {
      customValidators.push(Validators.pattern('^[a-zA-Z0-9]+$'));
    }

    return customValidators;
  }

  isFieldValid(field: string) {
    return !this.bankForm.get(field).valid && this.bankForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'is-error': this.isFieldValid(field),
      'required': this.bankForm.get(field).validator
    };
  }

  /** Get Size Limit in MB */
  private get fileSizeLimitMB() { return this.settings.fileSizeLimitMB * 1000000; }

  get documents(): FormArray {
    return this.documentsForm.get('documents') as FormArray;
  }

  get showIBANEdit() {
    return this.readOnly ? false : !this.isIBANEdited && !this.disableSensitiveFieldModification;
  }

  get showAccountNumberEdit() {
    return this.readOnly ? false : !this.isAccountNumberEdited && !this.isPlaidEnabled() && !this.disableSensitiveFieldModification;
  }

  get showIntermAccountNumberEdit() {
    return this.readOnly ? false : !this.isIntermediaryAccountNumberEdited;
  }

  /** Sumbit event handler of the bank details form */
  onBankDetailsSubmit() {
    validateAllFormFields(this.bankForm);
  }

  /** Submit event handler of the documents of the bank */
  onDocumentsSubmit() {
    validateAllFormFields(this.documentsForm);
  }

  //#region Select-Autocomplete Utilities
  currencyTextSelector(option: any): string {
    return !(isNullOrUndefined(option)) ? `${option['CODE']} - ${option['Name']}` : undefined;
  }

  currecyValueSelector(option: any): string {
    return !(isNullOrUndefined(option)) ? option['CODE'] : undefined;
  }
  //#region

  validateFile(formGroup: FormGroup) {
    if (formGroup && formGroup.value) {
      var ext = formGroup.value.fileName.substring(formGroup.value.fileName.lastIndexOf('.') + 1);
      var supplierDoc = this.types.find(x => x.name == this.supplierBankDocType);
      if (supplierDoc && supplierDoc.allowedExtensions) {
        if (!supplierDoc.allowedExtensions.toLowerCase().split(',').includes(ext.toLowerCase())) {
          this.invalidDoc = true;
          this.allowedExtensions = supplierDoc.allowedExtensions;
        }
        else {
          this.invalidDoc = false;
        }
      }
    }
  }

  CountryAutoCompleteValidator(control: AbstractControl, autoCompleteComponent: SelectAutocompleteComponent, error: string): ValidatorFn {
    return (): { [key: string]: any } | null => {
      if (control?.value) {
        let countryValue = control?.value as string;
        let selectedValue = autoCompleteComponent.selectedValue
        let countrySelected = this.countries.find(x => x.abbreviation == selectedValue);
        let isValid = countrySelected?.name == countryValue;
        if (isValid) {
          if (control.hasError(error)) {
            delete control.errors[error];
            control.updateValueAndValidity();
          }
          return null
        } else {
          control?.setErrors({ error: true });
          return { [error]: true };
        }
      }

      return null;
    };
  }

  CurrencyAutoCompleteValidator(control: AbstractControl, autoCompleteComponent: SelectAutocompleteComponent, error: string): ValidatorFn {
    return (): { [key: string]: any } | null => {
      if (control?.value) {
        let countryValue = control?.value as string;
        let selectedValue = autoCompleteComponent.selectedValue
        let countrySelected = this.currencies.find(x => x.CODE == selectedValue);
        let isValid = !isNullOrUndefined(countrySelected) ? this.currencyTextSelector(countrySelected) == countryValue : false;
        if (isValid) {
          if (control.hasError(error)) {
            delete control.errors[error];
            control.updateValueAndValidity();
          }
          return null
        } else {
          control?.setErrors({ error: true });
          return { [error]: true };
        }
      }

      return null;
    };
  }

  downloadSampleDocument() {
    this.onboardingDocumentsService.downloadBankSampleFile(localStorage.getItem('ttp-locale') ?? 'en-US').subscribe(resultBlob => {
      FileSaver.saveAs(resultBlob, 'Bank Document Example.pdf');
    })
  }
  usStateValiator(): ValidatorFn{
    return (control: AbstractControl): { [key: string]: any } | null => {
      const stateAbbreviations = US_STATE_LIST;
      if (control.value === null || control.value === '') {
        return null;
      } else if (!/^[A-Z]{2}$/.test(control.value)) {
        return { 'invalidFormat': true };
      } else if (!stateAbbreviations.includes(control.value)) {
        return { 'invalidState': true };
      } else {
        return null;
      }
    };
  }
}
